import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import DarkTooltip from "../../components/common/DarkToolTip"
import { ReactComponent as Danger } from "../../assets/images/run-payroll-preview/danger.svg"
import { getUser } from "../../store/auth/auth.selectors"
import { ReactSVG } from "react-svg"
import { useCan } from "../../hooks/useCan"

const LeftMenuItem = ({ menuItem, isCollapsed }) => {
  const nav = useNavigate()
  const location = useLocation()
  const userData = useSelector(getUser)
  const { icon, name, url, mui, redirect, permission, beta = false } = menuItem
  const canView = permission ? useCan(permission) : true

  const ifActive = location.pathname === url

  const handleNavigate = () => (redirect ? window.open(url, "_blank") : nav(url))

  const button = (
    <button
      onClick={handleNavigate}
      className={ifActive ? "active" : ""}
      style={{
        whiteSpace: "nowrap",
        lineHeight: "10px",
        width: isCollapsed ? "52px" : "100%",
        margin: isCollapsed ? "auto" : "0",
        position: "relative",
        justifyContent: isCollapsed ? 'center' : 'normal'
      }}>
      {mui ? icon : <ReactSVG src={icon} />}
      {!isCollapsed && name}
      {beta && <span className={`beta-label  ${isCollapsed ? 'beta-label-collapsed' : ''}`}>BETA</span>}
      {userData.has_missing_employees && name === "Employees" && (
        <Danger className={`danger menu-alert-label ${isCollapsed ? 'menu-alert-label-collapsed' : ''}`} />
      )}
    </button>
  )

  if (!canView) return
  return (
    <li>
      {isCollapsed ? (
        <DarkTooltip
          placement="right"
          title={name}
          styles={{
            right: "-10px",
            padding: "10px",
            marginLeft: "5px!important"
          }}>
          {button}
        </DarkTooltip>
      ) : (
        button
      )}
    </li>
  )
}

export default LeftMenuItem
